import React, { useEffect, useState } from "react";
import axios from "axios";
import Grid from "@mui/material/Grid";
import Card from "@mui/material/Card";
import Badge from "@mui/material/Badge";
import Icon from "@mui/material/Icon";
import CircularProgress from "@mui/material/CircularProgress";
import MDBox from "components/MDBox";
import MDTypography from "components/MDTypography";
import MDButton from "components/MDButton";
import DashboardLayout from "examples/LayoutContainers/DashboardLayout";
import DashboardNavbar from "examples/Navbars/DashboardNavbar";
import Footer from "examples/Footer";
import { useNavigate } from "react-router-dom";

function Setup() {
  const API_BASE_URL = process.env.REACT_APP_API_BASE_URL;
  const [loading, setLoading] = useState(true);
  const navigate = useNavigate();
  useEffect(() => {
    setLoading(false);
  }, []);
  const getAuthHeaders = () => {
    const token = sessionStorage.getItem("token");
    return {
      Authorization: `Bearer ${token}`,
    };
  };
  const handleNavigatepath = (path) => {
    window.location.href = "/admin/setup/client";
  };
  const handleNavigate = (path) => {
    navigate(`/admin/setup/${path}`);
  };

  return (
    <DashboardLayout>
      <DashboardNavbar />
      <MDBox pt={2} pb={3}>
        {loading ? (
          <MDBox display="flex" justifyContent="center" alignItems="center" minHeight="50vh">
            <CircularProgress color="info" />
          </MDBox>
        ) : (
          <Grid container spacing={2}>
            <Grid item xs={12}>
              <Card>
                {/* HEADER - Matching the standard card design */}
                <MDBox
                  mx={2}
                  mt={-1}
                  py={1}
                  px={2}
                  bgColor="info"
                  borderRadius="lg"
                  coloredShadow="info"
                  display="flex"
                  justifyContent="space-between"
                  alignItems="center"
                  flexWrap="wrap"
                  gap={1}
                >
                  <MDBox display="flex" alignItems="center" gap={1}>
                    <Icon sx={{ color: "#FFFFFF" }}>settings</Icon>

                    <MDTypography variant="h6" color="white">
                      SETUP
                    </MDTypography>
                  </MDBox>

                  <MDButton
                    variant="contained"
                    onClick={() => navigate("/dashboard")}
                    startIcon={<Icon>dashboard</Icon>}
                    sx={{
                      mb: 0,
                      color: "#FFFFFF",
                      backgroundColor: "rgba(255,255,255,0.18)",
                      "&:hover": {
                        backgroundColor: "rgba(255,255,255,0.28)",
                      },
                    }}
                  >
                    Dashboard
                  </MDButton>
                </MDBox>

                {/* CONTENT */}
                <MDBox p={3}>
                  <Grid container spacing={3}>
                    {/* Client Button */}
                    <Grid item xs={12} sm={4}>
                      <Badge color="error">
                        <MDButton
                          fullWidth
                          color="info"
                          variant="gradient"
                          size="large"
                          sx={{
                            width: { xs: "100%", sm: 300 },
                            height: "100px",
                            fontSize: "1rem",
                          }}
                          startIcon={<Icon>person</Icon>}
                          onClick={() => handleNavigate("client")}
                        >
                          MANAGE CLIENTS
                        </MDButton>
                      </Badge>
                    </Grid>
                  </Grid>
                </MDBox>
              </Card>
            </Grid>
          </Grid>
        )}
      </MDBox>
      <Footer />
    </DashboardLayout>
  );
}

export default Setup;
